import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'tw-h-4 tw-w-4 tw-border-2',
    md: 'tw-h-8 tw-w-8 tw-border-4',
    lg: 'tw-h-12 tw-w-12 tw-border-4',
  };

  return (
    <div
      className={`tw-inline-block tw-animate-spin tw-rounded-full tw-border-solid tw-border-current tw-border-r-transparent ${sizeClasses[size]} ${className}`}
      role="status"
    >
      <span className="tw-sr-only">Loading...</span>
    </div>
  );
};
